import { render, staticRenderFns } from "./StudentPastAppointmentsList.vue?vue&type=template&id=f767855a"
import script from "./StudentPastAppointmentsList.vue?vue&type=script&lang=js"
export * from "./StudentPastAppointmentsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/CoreProductivity.Backoffice.Mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f767855a')) {
      api.createRecord('f767855a', component.options)
    } else {
      api.reload('f767855a', component.options)
    }
    module.hot.accept("./StudentPastAppointmentsList.vue?vue&type=template&id=f767855a", function () {
      api.rerender('f767855a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/appointment/StudentPastAppointmentsList.vue"
export default component.exports